<template>
  <div class="_backoffice_empatik">

    <div class="d-flex align-center" :style="`font-size:25px; font-weight:700; color:${scdColor}; margin-bottom: 20px`">
			<v-btn @click="listaNotificheRoute()" depressed :color="scdColor" style="color:white; text-transform:none;" class="px-0 mr-6">
				<v-icon>mdi-arrow-left</v-icon>
			</v-btn>
			<div v-if="azione == 'nuova'">Nuova Notifica</div>
			<div v-if="azione == 'modifica'">Modifica Notifica</div>
		</div>

    <div class="d-flex">
      <v-form ref="inviaNotificaForm" style="width:800px; margin-right:20px;">
        <v-text-field
            label="Titolo"
            outlined
            v-model="datiForm.titolo"
            :rules="[vincoli.required]"
						@input="autosalvataggio('titolo', $event)"
          ></v-text-field>

          <ckeditor 
            :style="`${bordoCkeditor}`"
            v-model="datiForm.testo" 
            :config="editorConfig"
						@input="autosalvataggio('testo', $event)"
          ></ckeditor>

          <v-select
            item-text="nome_frontend"
            item-value="nome_backend"
            :items="tipi"
            label="Tipo"
            outlined
            v-model="datiForm.tipo"
            :rules="[vincoli.required]"
            style="margin-top:30px;"
          ></v-select>

          <v-select
            :items="destinatari"
            label="Destinatari"
            outlined
            v-model="datiForm.destinatari"
            :rules="[vincoli.required]"
          ></v-select>

					<div class="d-flex justify-end">
						<v-btn @click="validaForm('bozza')" depressed large :color="scdColor" style="color:white; text-transform:none;" class="px-6 mr-3">
							<span v-if="azione == 'modifica' && notifica.stato == 'Bozza'">Aggiorna bozza</span>
							<span v-if="azione == 'modifica' && notifica.stato == 'Inviata'">Converti in bozza</span>
							<span v-if="azione == 'nuova'">Salva come bozza</span>
						</v-btn>
						<v-btn @click="validaForm('invia')" depressed large :color="scdColor" style="color:white; text-transform:none;" class="px-6">
							<span v-if="azione == 'modifica'">Invia notifica modificata</span>
							<span v-if="azione == 'nuova'">Invia notifica</span>
						</v-btn>
					</div>
          
      </v-form>

      <div :style="`width:423px; background-color:#fff; padding:20px; border:2px solid ${datiAnteprima.colore}`">
        <div :style="`font-size:17px; font-weight:700; color:black;`">{{ datiAnteprima.titolo }}</div>
        <div :style="`font-size:10px; font-weight:600; color: ${ datiAnteprima.colore }; padding: 0 0 5px; border-bottom: 1px solid #d1d1d1`">{{ datiAnteprima.tipo }}</div>
        <div :style="`margin: 7px 0 0; font-size:13px; color:#434343;`" v-html="datiAnteprima.testo"></div>
        <div style="font-size:10px; font-weight:600; margin-top:10px;" class="d-flex justify-space-between">
          <div style="color:#b1b1b1;">1 minuto fa</div>
          <div :style="`color:${ scdColor }; cursor:pointer;`">Segna come letta</div>
        </div>
      </div>
    </div>

    <v-dialog persistent v-model="inviaNotificaDialog" max-width="550">
      <v-card>
        <v-card-title class="headline">
          <!-- <span :style="`color:${scdOrange}`" class="mr-2">Invia notifica</span> -->
        </v-card-title>
        <v-card-text>
          <p v-if="!bottoneInviaCliccato" :style="`font-size: 18px; font-weight:500; color:${scdColor}`">
            <span v-if="azione == 'modifica'">Vuoi modificare la notifica?</span><br>
            <span v-if="azione == 'modifica'" :style="`display:inline-block; margin-top:10px; font-size: 16px; font-weight:500; color:rgba(0,0,0,.6);`">La notifica risulterà agli utenti come "non letta" e "non visualizzata" e se hai scelto dei destinatari diversi verrà redistruibuita.</span>
            <span v-if="azione == 'nuova'">Vuoi inviare la notifica?</span>
          </p>
          <p v-if="invioNotificaInCorso" :style="`font-size: 18px; font-weight:500; color:${scdOrange}`">
            <span v-if="azione == 'modifica'">Modifica in corso...</span>
            <span v-if="azione == 'nuova'">Invio in corso...</span>
          </p>
          <v-progress-linear
            v-if="invioNotificaInCorso"
            :color="scdOrange"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="notificaInviata" :style="`font-size: 18px; font-weight:500; color:${scdColor}`">
            <span v-if="azione == 'modifica'">Notifica modificata!</span>
            <span v-if="azione == 'nuova'">Notifica inviata!</span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- :disabled="bottoniSceltaDisabilitati" -->
          <v-btn v-if="mostraBottoniScelta"  class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdColor" @click="inviaNotificaDialog = false">Annulla</v-btn>
          <v-btn v-if="mostraBottoniScelta && azione == 'nuova'" class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdOrange" @click="inviaNotifica()">Invia</v-btn>
          <v-btn v-if="mostraBottoniScelta && azione == 'modifica'" class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdOrange" @click="modificaNotifica()">Invia notifica modificata</v-btn>
          <v-btn v-if="mostraBottoneOkResetta" class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdColor" @click="resetta()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="salvaBozzaDialog" max-width="550">
      <v-card>
        <v-card-title>
          <!-- <span :style="`color:${scdOrange}`" class="mr-2">Invia notifica</span> -->
        </v-card-title>
        <v-card-text>
          <p v-if="salvataggioComeBozzaInCorso" :style="`font-size: 18px; font-weight:500; color:${scdOrange}`">
            <span>Salvataggio in corso...</span>
          </p>
          <v-progress-linear
            v-if="salvataggioComeBozzaInCorso"
            :color="scdOrange"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="!salvataggioComeBozzaInCorso" :style="`font-size: 18px; font-weight:500; color:${scdColor}`">
            <span>Bozza salvata!</span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!salvataggioComeBozzaInCorso" class="mb-1 px-4" style="text-transform:none;" dark rounded depressed :color="scdColor" @click="resetta()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import mixin from '../../../mixins';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  // props: ['azione', 'notifica'],
  data() {
    return {
			azione: null,
			notifica: null,
      tipi: [],
      destinatari: ['Amministratori', 'Amministratori e Coordinatori', 'Tutti'],
      datiForm: {
        titolo: '',
        testo: '',
        tipo: null,
        destinatari: null,
      },

      datiAnteprima: {
        titolo: 'Titolo',
        testo: '',
        tipo: 'Tipo',
        colore: '#b1b1b1',
        destinatari: ''
      },

      inviaNotificaDialog: false,
      bottoneInviaCliccato: false,
      invioNotificaInCorso: false,
      // bottoniSceltaDisabilitati: false,
      mostraBottoniScelta: true,
      mostraBottoneOkResetta: false,
      notificaInviata: false,

      salvaBozzaDialog: false,
      salvataggioComeBozzaInCorso: false,

      editor: ClassicEditor,
      editorConfig: {
          // The configuration of the editor.
      },
      bordoCkeditor: 'border:none;'
    }
  },
  watch: {
    'datiForm.tipo': function(nomeBackend, oldVal) {
      this.tipi.forEach(tipo => {
        if(tipo.nome_backend == nomeBackend) {
          this.datiAnteprima.tipo = tipo.nome_frontend
          this.datiAnteprima.colore = tipo.colore
        }
      })
    },
    'datiForm.titolo': function(titolo, oldVal) {
      this.datiAnteprima.titolo = titolo;
    },
    'datiForm.testo': function(testo, oldVal) {
      this.datiAnteprima.testo = testo;

      if (testo.length <= 0 && !this.notificaInviata) {
        this.bordoCkeditor = `
        border: 2px solid #ff5252;
        border-radius: 3px;
        `;
      } else if (testo.length > 0) {
        this.bordoCkeditor = 'border: none;'
      }
    },
    'datiForm.destinatari': function(destinatari, oldVal) {
      this.datiAnteprima.destinatari = destinatari;
    },
  },
  async created() {
		this.azione = this.$route.params.azione;
		this.notifica = this.$route.params.notifica;

    await this.getTipi();

    if (this.azione == 'modifica') {
      this.datiForm = {
        titolo: this.notifica.titolo,
        testo: this.notifica.testo,
        tipo: this.notifica.tipo,
        destinatari: this.notifica.destinatari
      }
    }
  },
  methods: {
		autosalvataggio(field, data) {
			// localStorage.setItem(field, data);
		},
		listaNotificheRoute() {
			this.$router.push({ name: 'notifiche' });
		},
    getTipi() {
      return axios
      .get('notifiche/get-tipi')
      .then(response => {
        this.tipi = response.data;
      })
    },
    validaForm(azione) {
      let ciSonoCampiNonCompilati = false;
      if(!this.$refs.inviaNotificaForm.validate()){
        ciSonoCampiNonCompilati = true;
      }
      if (this.datiForm.testo.length <= 0) {
        ciSonoCampiNonCompilati = true;
        this.bordoCkeditor = `
        border: 2px solid #ff5252;
        border-radius: 3px;
        `;
      } else {
        this.bordoCkeditor = 'border:none';
      }

      if (ciSonoCampiNonCompilati) {
        return;
      }

      if (azione == 'invia') {
        this.inviaNotificaDialog = true;

      } else if (azione == 'bozza') {
        this.salvaComeBozza();
      }
    },
    inviaNotifica() {
      this.bottoneInviaCliccato = true;
      this.invioNotificaInCorso = true;
      this.mostraBottoniScelta = false;

      axios
      .post('/backoffice/notifiche/invia', {
        titolo: this.datiForm.titolo,
        testo: this.datiForm.testo,
        tipo: this.datiForm.tipo,
        destinatari: this.datiForm.destinatari
      })
      .then(response => {
        if (response.hasError) {
          // segnalo errore sul front end
        } else {
          this.notificaInviata = true;
          this.$refs.inviaNotificaForm.reset();
          this.datiForm.testo = '';
          this.bordoCkeditor = 'border: none;'
        }
      })
      .finally(() => {
        this.invioNotificaInCorso = false;
        this.mostraBottoneOkResetta = true;
      })

    },
    modificaNotifica() {
      this.bottoneInviaCliccato = true;
      this.invioNotificaInCorso = true;
      this.mostraBottoniScelta = false;

      axios.post('/backoffice/notifiche/modifica', {
        notifica: {
          id: this.notifica.id,
          titolo: this.datiForm.titolo,
          testo: this.datiForm.testo,
          tipo: this.datiForm.tipo,
          destinatari: this.datiForm.destinatari
        }
      })
      .then(response => {
        if (response.hasError) {
          // segnalo errore sul front end
        } else {
          this.notificaInviata = true;
        }
      })
      .finally(() => {
        this.invioNotificaInCorso = false;
        this.mostraBottoneOkResetta = true;
      })
    },
    resetta() {
      this.inviaNotificaDialog = false;
      this.notificaInviata = false;
      this.bottoneInviaCliccato = false;
      this.mostraBottoniScelta = true;
      this.mostraBottoneOkResetta = false;

			this.listaNotificheRoute();

      this.salvaBozzaDialog = false;

      // this.$emit('chiudi-dialog');
      // this.$emit('aggiorna-tabella-notifiche');
    },
    salvaComeBozza() {
      this.salvaBozzaDialog = true;
      this.salvataggioComeBozzaInCorso = true;

			let notifica = {
				id: null,
				titolo: this.datiForm.titolo,
				testo: this.datiForm.testo,
				tipo: this.datiForm.tipo,
				destinatari: this.datiForm.destinatari
			}

			if (this.azione == 'modifica') {

				notifica.id = this.notifica.id;
			}

      axios.post('notifiche/salva-come-bozza', notifica)
      .then(res => {
        this.salvataggioComeBozzaInCorso = false;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  ._backoffice_empatik {
    font-family: 'Montserrat', sans-serif !important;
  }
</style>